import { render, staticRenderFns } from "./EditorLanguage.vue?vue&type=template&id=e6c8878e&scoped=true&"
import script from "./EditorLanguage.vue?vue&type=script&lang=ts&"
export * from "./EditorLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./EditorLanguage.vue?vue&type=style&index=0&id=e6c8878e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c8878e",
  null
  
)

export default component.exports